module.exports = __webpack_public_path__ + "img/login-image-02.f9cbc399.png";